import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";
import TriageTableData from "../interfaces/triageTableData";
import { ApiResponse } from "../interfaces/response";
import { Service } from "../interfaces/service";
import { Establishment } from "../interfaces/establishment";

const API_URL = 'https://7jpfphjjix3kvkebml3wozns7a0vkavr.lambda-url.sa-east-1.on.aws';

export async function fetchTriages(establishmentId: string): Promise<TriageTableData[] | null> {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();

    if (!token) throw new Error("Usuário não autenticado!");

    const response = await axios.get<ApiResponse<TriageTableData[]>>(
      `${API_URL}?establishment_id=${establishmentId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log(response.data);
    return response.data.data;
  } catch (error) {
    console.error("Erro ao buscar triagens:", error);
    return null;
  }
}

export async function getEstablishmentById(establishmentId: string): Promise<Establishment | null> {
  try {
    const response = await axios.get<ApiResponse<Establishment>>(
      `${API_URL}/establishment/${establishmentId}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Erro ao buscar estabelecimento:", error);
    return null;
  }
}

export async function postTriages(triageData: TriageTableData[]) {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();

    if (!token) throw new Error("Usuário não autenticado!");

    const response = await axios.post<ApiResponse<any>>(
      API_URL,
      triageData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Erro ao enviar triagens:", error);
    return null;
  }
}

export async function getServicesByEstablishment(establishmentId: string): Promise<Service[] | null> {
  try {
    const response = await axios.get<ApiResponse<Service[]>>(
      `${API_URL}/service?establishment_id=${establishmentId}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Erro ao buscar serviços:", error);
    return null;
  }
}
